import React, { useState, useEffect } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import DataGrid from "components/data-grid";
import { QueryResponseHandler } from "components/graphql";
import { useCurrentCustomerContext } from "components/current-customer-context";
import {
  validationSchema,
  defaultValues,
  handleSubmit,
  EditDeploymentForm,
} from "./forms/edit-form";
import ValidatedForm from "components/form";
import { getDeploymentService } from "../../services/deploymentServices";

const DeploymentEditPage = ({
  intl,
  history,
  match: {
    params: { id },
  },
}) => {
  const { currentCustomerId } = useCurrentCustomerContext();

  const [deployment, setDeployment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [initialValues, setInitialValues] = useState(defaultValues);

  const mapDeploymentToFormValues = data => ({
    ...data,
    connectivityFixedIp: data.connectivity_fixed_ip ?? false,
    mobileBox: data.mobile_box ?? false,
    usuallyDisconnected: data.usually_disconnected ?? false,
    allowsConcurrentEvents: data.allow_concurrent_events ?? null,
    allowQod: data.allow_qod ?? false,
    msisdnQod: data.msisdn_qod ?? "",
    proxyPtz: data.proxy_ptz ?? { protocol: "", hostname: "", port: 0 },
    awsElasticIps: data.aws_elastic_ip ?? [],
    ownedByPartnerId: data.owned_by_partner_id ?? null,
    place: data.place
      ? {
          name: data.place.name ?? "",
          telephone: data.place.telephone ?? "",
          address: data.place.address ?? "",
          serverNtp: data.place.server_ntp ?? "",
          timeZone: data.place.time_zone ?? "",
          daylightSaving: data.place.daylight_saving ?? true,
          geo: data.place.geo ?? { latitude: 0, longitude: 0 },
        }
      : defaultValues.place,
  });

  const getDeployment = () => {
    setLoading(true);
    getDeploymentService(
      { deploymentId: id },
      data => {
        setDeployment(data);
        setInitialValues(mapDeploymentToFormValues(data));
        setLoading(false);
      },
      e => {
        setError(e);
        setLoading(false);
      },
    );
  };

  useEffect(
    () => {
      getDeployment();
    },
    [id],
  );

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={deployment}>
        <PageHeaderBar title="app.page.deployment.edit" />
        <PageSection>
          <ValidatedForm
            initialValues={initialValues}
            validationSchema={validationSchema(intl)}
            onSubmit={handleSubmit({
              history,
              currentCustomerId,
              deploymentId: id,
            })}
          >
            {props => {
              return (
                <DataGrid>
                  <EditDeploymentForm {...props} />
                </DataGrid>
              );
            }}
          </ValidatedForm>
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default DeploymentEditPage;
